import React from 'react';
import successLottie from '../../utils/Lottie/success.json';
import { DatabaseOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, Button, Stack, Typography } from '@mui/material';
import Lottie from 'lottie-react';

function OrderComplete() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onGoBack = () => {
    dispatch({ type: 'RESET_FMCG_REDUCER' });
    dispatch({ type: 'CLEAR_RETAILERS' });
    dispatch({ type: 'RESET_BCM_ORDER' });

    navigate('/distributor/company-wise-inventory', { replace: true });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '25px',
        height: '100vh',
      }}
    >
      <Stack
        display='flex'
        alignItems='center'
        direction='column'
        sx={{ flexGrow: 1, justifyContent: 'center' }}
      >
        <Lottie
          animationData={successLottie}
          loop={true}
        />
        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 600,
            color: '#000',
            marginTop: '20px',
            textAlign: 'center',
          }}
        >
          Inventory allocation completed successfully.
        </Typography>
      </Stack>

      <Button
        fullWidth
        onClick={onGoBack}
        startIcon={<DatabaseOutlined />}
        className='returnToInventory'
        variant='outlined'
        sx={{ maxWidth: 400 }} // optional: limit button width
      >
        Return To Inventory
      </Button>
    </Box>
  );
}

export default OrderComplete;
